import { nonsenseWordRepetitionStates } from './nonsenseWordRepetitionStates'
const STATES = {...nonsenseWordRepetitionStates}

export const getNextNonsenseWordRepetitionState = ({currentState, isExamplePhraseOfThisType, didAttempt}) => {
    let nextState = null
    switch (currentState) {
      case STATES.LOADING:
        if(isExamplePhraseOfThisType){
          nextState = STATES.PLAY_EXAMPLE_INTRO
        } else {
          nextState = STATES.PLAY_VIDEO
        }
        break;
      case STATES.PLAY_EXAMPLE_INTRO:
        nextState = STATES.PLAY_VIDEO
        break;
      case STATES.PLAY_VIDEO:
        if(isExamplePhraseOfThisType){
          nextState = STATES.PLAY_EXAMPLE_PROMPT
        } else {
          nextState = STATES.WAITING_FOR_USER_INPUT_AFTER_PROMPT
        }
        break;
      case STATES.PLAY_EXAMPLE_PROMPT:
        nextState = STATES.WAITING_FOR_USER_INPUT_AFTER_PROMPT
        break;
      case STATES.WAITING_FOR_USER_INPUT_AFTER_PROMPT:
        if(isExamplePhraseOfThisType){
          if(didAttempt){
            nextState = STATES.REGISTER_EXAMPLE_ENDING_SPEECH
          }else{
            nextState = STATES.PLAY_EXAMPLE_REPROMPT
          }
        } else {
          if(didAttempt){
            nextState = STATES.REGISTER_EXAMPLE_ENDING_SPEECH
          }else{
            nextState = STATES.PLAY_REPROMPT
          }
        }
        break;
      case STATES.PLAY_EXAMPLE_REPROMPT:
        nextState = STATES.WAITING_FOR_USER_INPUT_AFTER_REPROMPT
        break;
      case STATES.PLAY_REPROMPT:
        nextState = STATES.WAITING_FOR_USER_INPUT_AFTER_REPROMPT
        break;
      case STATES.WAITING_FOR_USER_INPUT_AFTER_REPROMPT:
        if(didAttempt){
          nextState = STATES.REGISTER_EXAMPLE_ENDING_SPEECH
        }
        break;
      case STATES.REPLAY_VIDEO:
        nextState = STATES.WAITING_FOR_USER_INPUT_AFTER_REPLAY
        break;
      case STATES.WAITING_FOR_USER_INPUT_AFTER_REPLAY:
        if(didAttempt){
          nextState = STATES.REGISTER_EXAMPLE_ENDING_SPEECH
        }
        break;
      case STATES.REGISTER_EXAMPLE_ENDING_SPEECH:
        nextState = STATES.WAITING_FOR_ENDING_SPEECH;
        break;
      default:
        break;
    }
    if(nextState){
      console.log("Going to next state", currentState, "=>", nextState, "")
      return nextState
    }else{
      console.log("No next state, staying in ", currentState)
      return null
    }
  }